;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';

import styles from './Description.module.scss';

const Description = ({ headline, svgIcon, eyebrow, bodyCopy, cta }) => {
    return (
        <div className={styles.root}>
            <div className={styles.inner}>
                <Lockup
                    icon={svgIcon}
                    eyebrow={{ text: eyebrow }}
                    headline={{ text: headline }}
                    copy={{ text: bodyCopy }}
                    ctas={cta}
                    theme="Medium"
                />
            </div>
        </div>
    );
};

Description.propTypes = {
    eyebrow: PropTypes.string,
    headline: PropTypes.object.isRequired,
    svgIcon: PropTypes.object,
    bodyCopy: PropTypes.object.isRequired,
    cta: PropTypes.object.isRequired,
};

export default Description;
